/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useCallback } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import { TextField } from '@material-ui/core';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../../../SharedModules/RadioGroup/RadioGroupBtn';
import { NDCDetailsTextFieldComponent } from '../../../../Display/NDC/component/NDCDetails/NDCDetailsHeaderDetailsComponent';
import {
  convertPDFFromAPI,
  isCheckDateFormat,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';

import {
  PLAN_TYPE_DATA,
  SELECT_TYPE_DATA,
} from '../../OnlineFixes/CreateStubInvoice/utils/constant';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import {
  REBATE_PROGRAM_REQUIRED,
  DATE_REQUIRED,
  REQUEST_DATE_INVALID_FORMAT,
  MINIMUM_START_DATE_VALUE,
  MINIMUM_START_DATE,
  MINIMUM_FORM_DATE,
  TO_QTR_CANT_BE_LESS_THAN_FROM,
  QTR_VALIDATION_ERR,
  DATE_RANGE_ERR,
  TO_DATE_CANT_BE_LESS_THAN_FROM,
  FROM_DATE_QUARTER_REQUIRED,
  To_DATE_QUARTER_REQUIRED,
  END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
  END_DATE_GREATER_THAN_START_DATE,
  REBATE_SELECT,
} from '../../../../../SharedModules/Errors/constantMessageData';
import {
  setPlanType,
  setSelectType,
  setRebateProgram,
  setStartDate,
  setEndDate,
  setErrors,
  setNetworkError,
  getRebateProgramCodePRT,
} from '../store/actions';
import { DateRangeValidation } from '../../../../../SharedModules/DateRangeValiation.js';
import { QUARTER_FORMAT_ERROR } from '../../../../../SharedModules/AppConstants';
import { autoFormateDate } from '../../../../../SharedModules/utilities/utilities';
import {
  compareDate,
  validateDateQuarter,
} from '../../../../../SharedModules/utilities/dateUtilities';
import { truncate } from 'lodash';
import { useState } from 'react';

const PeriodicReportHeader = ({ setErrorMessages, setLoading }) => {
  const dispatch = useDispatch();

  /** Default Data from redux */
  const rebateDropdownData = useSelector(
    (state) => state?.sharedState?.PeriodicReportReducer?.rebate_list
  );
  const defaultPlanType = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.planTypeCd
  );
  const defaultRebateCd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.rebateProgramCd
  );

  /** Periodic Report data */
  const planType = useSelector(
    (state) => state?.sharedState?.PeriodicReportReducer?.planType
  );
  const selectType = useSelector(
    (state) => state?.sharedState?.PeriodicReportReducer?.selectType
  );
  const rebateProgram = useSelector(
    (state) => state?.sharedState?.PeriodicReportReducer?.rebateProgram
  );
  const startDate = useSelector(
    (state) => state?.sharedState?.PeriodicReportReducer?.startDate
  );
  const endDate = useSelector(
    (state) => state?.sharedState?.PeriodicReportReducer?.endDate
  );
  const errors = useSelector(
    (state) => state?.sharedState?.PeriodicReportReducer?.errorMessages
  );
  const PeriodicReportReducer = useSelector(
    (state) => state?.sharedState?.PeriodicReportReducer
  );
  const userId = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data?.userId
  );

  const dispatchPlanType = useCallback(
    (value) => {
      dispatch(setPlanType(value));
    },
    [planType]
  );

  const dispatchSelectType = useCallback(
    (value) => {
      dispatch(setSelectType(value));
    },
    [selectType]
  );

  const dispatchRebateProgram = useCallback(
    (value) => {
      dispatch(setRebateProgram(value));
    },
    [rebateProgram]
  );

  const dispatchStartDate = useCallback(
    (value) => {
      dispatch(setStartDate(value));
    },
    [startDate]
  );

  const dispatchEndDate = useCallback(
    (value) => {
      dispatch(setEndDate(value));
    },
    [endDate]
  );

  const dispatchErrors = useCallback(
    (value) => {
      dispatch(setErrors(value));
    },
    [errors]
  );

  useEffect(() => {
    if (!planType && defaultPlanType) {
      dispatchPlanType(defaultPlanType);
    } else if (!planType && (!defaultPlanType || defaultPlanType != -1)) {
      dispatchPlanType('FD');
    }
  }, [defaultPlanType]);

  useEffect(() => {
    if (planType) dispatch(getRebateProgramCodePRT(planType));
    if (planType !== defaultPlanType) dispatchRebateProgram(null);
    else dispatchRebateProgram(defaultRebateCd);
  }, [planType]);

  useEffect(() => {
    dispatchRebateProgram(defaultRebateCd);
  }, [defaultRebateCd]);
  const [rebateProgramError, setRebatePrograError] = useState(false);
  const validFilter = () => {
    dispatch(setNetworkError(false));
    let allErrors = [];
    if (rebateProgram === '-1') {
      allErrors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
      setRebatePrograError(true);
    }
    let fromError = [];
    if (selectType === 'single') {
      fromError = validateDateQuarter(filterValue.fromDate, 'fromDate');
    }
    let toError = validateDateQuarter(filterValue.toDate, 'toDate');
    if (
      selectType === 'single' &&
      fromError.length === 0 &&
      toError.length === 0
    ) {
      if (compareDate(filterValue.fromDate, filterValue.toDate)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: END_DATE_GREATER_THAN_START_DATE,
        });
        setFormErrMsg({
          ...formErrMsg,
          toDate: END_DATE_GREATER_THAN_START_DATE.replace(
            /date/g,
            'date/quarter'
          ),
        });
        setFormError({ ...formError, toDate: true });
      }
    }
    if (selectType === 'single' && fromError.length > 0 && toError.length > 0) {
      setFormErrMsg({
        ...formErrMsg,
        fromDate: fromError[0].message?.replace(
          'From date is required.',
          'Start date is required for generating Single Period Report.'
        ),
        toDate: toError[0].message?.replace(
          'To date is required.',
          'End date is required for generating Single Period Report.'
        ),
      });
      setFormError({ toDate: true, fromDate: true });
    } else {
      if (selectType === 'single' && fromError.length > 0) {
        setFormErrMsg({
          ...formErrMsg,
          fromDate: fromError[0].message?.replace(
            'From date is required.',
            'Start date is required for generating Single Period Report.'
          ),
        });
        setFormError({ ...formError, fromDate: true });
      }
      if (toError.length > 0) {
        if (selectType === 'single') {
          setFormErrMsg({
            ...formErrMsg,
            toDate: toError[0].message?.replace(
              'To date is required.',
              'End date is required for generating Single Period Report.'
            ),
          });
        } else {
          setFormErrMsg({
            ...formErrMsg,
            toDate: toError[0].message?.replace(
              'To date is required.',
              'End date is required for generating Cumulative Report.'
            ),
          });
        }

        setFormError({ ...formError, toDate: true });
      }
    }
    allErrors = [...allErrors, ...fromError, ...toError];
    setErrorMessages(allErrors);
    return allErrors;
  };
  const convertDateToQuarter = (date) => {
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const quarter = Math.ceil(month / 3);
    return `${quarter}Q${year}`;
  };

  const findOnDayGreterThanStartDate = () => {
    return moment(new Date()).format('MM/DD/YYYY');
  };

  const downloadPDFFile = async () => {
    let getDate = '';
    let { fromDate, toDate } = filterValue;

    if (fromDate.length === 7) {
      fromDate = fullDate(fromDate, 'fromDate');
    }

    if (toDate.length === 7) {
      toDate = fullDate(toDate, 'toDate');
    }

    const getDateFormat = (data, key) => {
      if (data.charAt(1) === 'Q') {
        if (data.length === 6) {
          return DateRangeValidation(data, key, true);
        }
        if (data.length === 4) {
          return DateRangeValidation(data, key, false);
        }
      } else {
        return moment(data).format('MM/DD/YYYY');
      }
    };

    if (!formError.fromDate && fromDate !== '' && toDate === '') {
      let startFromDate = fromDate;
      if (fromDate.charAt(1) === 'Q') {
        if (fromDate.length === 6) {
          startFromDate = DateRangeValidation(fromDate, 'fromDate', true);
        } else if (fromDate.length === 4) {
          startFromDate = DateRangeValidation(fromDate, 'fromDate', false);
        }
      }
      const getlastMonth = (month) => {
        if (month == 1 || month == 2 || month == 3) return 3;
        if (month == 4 || month == 5 || month == 6) return 6;
        if (month == 7 || month == 8 || month == 9) return 9;
        if (month == 10 || month == 11 || month == 12) return 12;
      };
      const month = getlastMonth(new Date(startFromDate).getMonth() + 1);
      const year = new Date(startFromDate).getFullYear();
      const lastDate = new Date(Number(year), Number(month), 0).getDate();
      getDate = `${month}/${lastDate}/${year}`;

      setFilterValue((prev) => ({
        ...prev,
        toDate: getDate,
      }));
    }

    const payload = {
      selectBy: selectType,
      rebateProgramCode: rebateProgram,
      userId: userId,
      endDate: getDateFormat(
        filterValue.toDate !== '' ? toDate : getDate,
        'toDate'
      ),
    };
    if (selectType === 'single') {
      payload.startDate = getDateFormat(fromDate, 'fromDate');
    }
    setLoading(true);
    try {
      const response = await axios.post(
        `${serviceEndPoint.CREATE_PERIODIC_BALANCE_REPORT}`,
        payload,
        {
          responseType: 'arraybuffer',
          headers: {
            Accept: 'application/octet-stream',
          },
        }
      );
      setLoading(false);
      convertPDFFromAPI(response.data);
      dispatch(setNetworkError(false));
    } catch (error) {
      if (
        error.message === 'Network Error' ||
        error.message === 'Request failed with status code 502'
      ) {
        dispatch(setNetworkError(true));
      }
      setLoading(false);
      convertPDFFromAPI([]);
    }
  };

  const handleDateChange = (key, val) => {
    val = val.toUpperCase(); // Convert to uppercase
    formError[key] = false;
    // formError.toDate = false;
    formErrMsg[key] = '';
    // formErrMsg.fromDate = '';
    // setErrorMessages([]);

    const data = val;
    const filterObject = filterValue;
    filterObject[key] = data;
    dispatch(setStartDate(filterObject));
    setFormError((prev) => ({
      ...prev,
    }));
    setFormErrMsg((prev) => ({
      ...prev,
    }));
    setFilterValue((prev) => ({
      ...prev,
      [key]: data,
    }));
  };

  const fullDate = (date, key) => {
    if (date.length === 7) {
      const datearr = date.split('/');
      const month = datearr[0];
      const year = datearr[1];
      const lastDate = new Date(Number(year), Number(month), 0).getDate();
      return `${month}/${key === 'toDate' ? lastDate : '01'}/${year}`;
    }
    return date;
  };
  const [formError, setFormError] = React.useState({
    fromDate: false,
    toDate: false,
  });
  const [formErrMsg, setFormErrMsg] = React.useState({
    fromDate: '',
    toDate: '',
  });
  const [filterValue, setFilterValue] = React.useState({
    fromDate: '',
    toDate: '',
  });

  const onBlurDateChange = (type, input, select) => {
    dispatch(setNetworkError(false));
    let value = autoFormateDate(input);
    let allErrors = errors;
    let fromError = [];
    let toError = [];
    if (type === 'fromDate') {
      setFilterValue({ ...filterValue, [type]: value.toUpperCase() });
      allErrors = allErrors.filter((error) => error.field !== 'fromDate');
      fromError = validateDateQuarter(value, 'fromDate');

      allErrors = [...allErrors, ...fromError];
      if (fromError.length > 0) {
        setFormErrMsg({
          ...formErrMsg,
          [type]: fromError[0].message?.replace(
            'From date is required.',
            'Start date is required for generating Single Period Report.'
          ),
        });
        setFormError({ ...formError, [type]: true });
      }

      setErrorMessages(allErrors);
    }
    if (type === 'toDate') {
      setFilterValue({ ...filterValue, [type]: value.toUpperCase() });
      allErrors = allErrors.filter((error) => error.field !== 'toDate');
      allErrors = allErrors.filter(
        (error) => error.field !== 'fromDate>toDate'
      );
      toError = validateDateQuarter(value, 'toDate');
      allErrors = [...allErrors, ...toError];
      if (toError.length > 0) {
        if (select === 'CL') {
          setFormErrMsg({
            ...formErrMsg,
            [type]: toError[0].message?.replace(
              'To date is required.',
              'End date is required for generating Cumulative Report.'
            ),
          });
        } else {
          setFormErrMsg({
            ...formErrMsg,
            [type]: toError[0].message?.replace(
              'To date is required.',
              'End date is required for generating Single Period Report.'
            ),
          });
        }

        setFormError({ ...formError, [type]: true });
      }

      setErrorMessages(allErrors);
    }
    if (fromError.length === 0 && toError.length === 0) {
      allErrors = allErrors.filter(
        (error) => error.field !== 'fromDate>toDate'
      );
      allErrors = allErrors.filter((error) => error.field !== 'toDate');
      if (compareDate(filterValue.fromDate, filterValue.toDate)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: END_DATE_GREATER_THAN_START_DATE,
        });

        allErrors = [...allErrors, ...toError];
        setFormErrMsg({
          ...formErrMsg,
          toDate: END_DATE_GREATER_THAN_START_DATE.replace(
            /date/g,
            'date/quarter'
          ),
        });
        setFormError({ ...formError, toDate: true });
      } else {
        setFormErrMsg({
          ...formErrMsg,
          toDate: '',
        });
        setFormError({ ...formError, toDate: false });
      }

      setErrorMessages(allErrors);
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-5 col-lg-5 col-md-6 col-sm-7 frr-radio-40per-width">
          <RadioGroupComponent
            id="plan-type-radio-btn-action"
            optionList={PLAN_TYPE_DATA}
            labelName={'Plan Type'}
            defaultValue={planType}
            filterAction={(e) => dispatchPlanType(e)}
            className="log-batch-filter-radio"
          />
        </div>
        <div className="col-3">
          <RadioGroupComponent
            id="select-radio-btn-action"
            optionList={SELECT_TYPE_DATA}
            labelName={'Select'}
            defaultValue={selectType}
            filterAction={(value) => {
              dispatchSelectType(value);
              dispatchStartDate(null);
              dispatchEndDate(null);
              setErrorMessages([]);
              setFormError({
                ...formError,
                fromDate: false,
                toDate: false,
              });
              setFormErrMsg({
                ...formErrMsg,
                fromDate: '',
                toDate: '',
              });
              setFilterValue({
                ...filterValue,
                fromDate: '',
                toDate: '',
              });
            }}
          />
        </div>
        <div className="col-4 mt-2">
          <fieldset className="custom-fieldset mandate-fields">
            <NDCDetailsTextFieldComponent
              label="Rebate Program"
              required
              value={rebateProgram}
              error={rebateProgramError}
              className="ml-0 with-select"
              select
              selectReset
              selectData={rebateDropdownData}
              disabled={false}
              helperText={
                errors.find((error) => error.field === 'rebateProgram')
                  ?.message || ''
              }
              onChange={(e) => {
                if (e.target.value && e.target.value != -1) {
                  setRebatePrograError(false);
                  setErrorMessages(
                    errors.filter((o) => o.field !== 'rebateProgram')
                  );
                } else {
                  setRebatePrograError(true);
                  setErrorMessages([
                    ...errors,
                    {
                      field: 'rebateProgram',
                      message: REBATE_PROGRAM_REQUIRED,
                    },
                  ]);
                }
                dispatchRebateProgram(e.target.value);
              }}
            />
          </fieldset>
        </div>
        {selectType === 'single' ? (
          <div className="col-5 mt-2">
            <fieldset className="custom-fieldset">
              <legend>
                Date Range/Qtr. Range
                <span className="mandatory"> *</span>
              </legend>
              <div className="row">
                <div className="col-sm-12">
                  <div className="mui-zip-flex" style={{ display: 'contents' }}>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="mui-custom-textField input-md w-100">
                          <TextField
                            className={`mandate-fields`}
                            label="From"
                            id="from-req"
                            fullWidth
                            placeholder=""
                            inputProps={{ maxLength: 10, id: 'from-req' }}
                            value={filterValue.fromDate}
                            data-testid="paidDateRange"
                            onChange={(date) => {
                              handleDateChange('fromDate', date.target.value);
                            }}
                            helperText={
                              formError.fromDate ? formErrMsg.fromDate : null
                            }
                            error={
                              formError.fromDate ? formError.fromDate : null
                            }
                            onBlur={(e) =>
                              onBlurDateChange('fromDate', e.target.value, 'SP')
                            }
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="mui-custom-textField input-md w-100">
                          <TextField
                            className={`mandate-fields`}
                            label="To"
                            id="to-req"
                            fullWidth
                            placeholder=""
                            inputProps={{ maxLength: 10, id: 'to-req' }}
                            value={filterValue.toDate}
                            data-testid="toDate"
                            onChange={(event) => {
                              handleDateChange('toDate', event.target.value);
                            }}
                            helperText={
                              formError.toDate ? formErrMsg.toDate : null
                            }
                            error={formError.toDate ? 'mandate-fields' : null}
                            onBlur={(e) =>
                              onBlurDateChange('toDate', e.target.value, 'SP')
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        ) : (
          <div className="col-5 mt-2">
            <fieldset className="custom-fieldset">
              <legend>
                End Date/Qtr.
                <span className="mandatory"> *</span>
              </legend>
              <div className="row">
                <div className="col-sm-12">
                  <div className="mui-zip-flex" style={{ display: 'contents' }}>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="mui-custom-textField input-md w-100">
                          <TextField
                            className={`mandate-fields`}
                            label="To"
                            id="to-req"
                            fullWidth
                            placeholder=""
                            inputProps={{ maxLength: 10, id: 'to-req' }}
                            value={filterValue.toDate}
                            data-testid="toDate"
                            onChange={(event) => {
                              handleDateChange('toDate', event.target.value);
                            }}
                            helperText={
                              formError.toDate ? formErrMsg.toDate : null
                            }
                            error={formError.toDate ? formError.toDate : null}
                            onBlur={(e) =>
                              onBlurDateChange('toDate', e.target.value, 'CL')
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        )}
        <div
          className={`${
            selectType === 'single' ? 'col-7' : 'col-7'
          } mt-4 my-3 d-flex align-items-center justify-content-end`}
        >
          <Button
            className="btn-success same-font-family d-flex align-items-center"
            onClick={() => {
              const validateFilter = validFilter();
              if (validateFilter.length == 0) {
                downloadPDFFile();
              }
            }}
          >
            <SVGComponent iconName="Create-new-icon" />
            &nbsp;Process
          </Button>
        </div>
      </div>
    </>
  );
};
export default PeriodicReportHeader;
